import { render, staticRenderFns } from "./CustomersAndSuppliers.vue?vue&type=template&id=6544ab5d"
import script from "./CustomersAndSuppliers.vue?vue&type=script&lang=js"
export * from "./CustomersAndSuppliers.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports